//+++++++++++++++++++++++++++++++++++++++++++++++
// ANIMATION
//+++++++++++++++++++++++++++++++++++++++++++++++
// Different functions and classes, that deal
// with js animation. Default Easing is
// easeInOutQuad
//+++++++++++++++++++++++++++++++++++++++++++++++

DW.Animate = function(duration, increment, easing, start, change, doOnIncrement, callback) {

  duration = (parseInt(duration) > 0) ? parseInt(duration) : 500;
  easing = (easing !== '') ? easing : 'easeInOutQuad';
  var currentTime = 0;
  var loop = function() {
    currentTime += increment;
    var easingFunctions = new DW.EasingFunctions();
    var val = easingFunctions[easing](currentTime, start, change, duration);
    // var val = EasingFunctions.easeOutBounce(currentTime, start, change, duration);
    if(doOnIncrement && typeof(doOnIncrement) === 'function') {
      doOnIncrement(val);
    }
    if(currentTime < duration) {
      setTimeout(function() {
        loop();
      }, increment);
    } else {
      if(callback && typeof(callback) === 'function') {
        callback();
      }
    }
  };

  loop();
};

//=require DW.EasingFunctions.js
